export const defaults = { focus: 25, rest: 5, rounds: 4 }
export function durations(settings) {
  return Array.from(
    { length: settings.rounds * 2 - 1 },
    (_, i) => settings[i % 2 ? 'rest' : 'focus'] * 60,
  )
}
export function total(settings) {
  return durations(settings).reduce((sum, seconds) => sum + seconds, 0)
}
export function elapsed(state, now) {
  return Math.min(
    total(state.settings),
    state.elapsed +
      (state.status === 'running' ? Math.max(0, now - state.resumed_at) : 0),
  )
}
export function phase(state, now) {
  if (state.status === 'running' && state.resumed_at > now)
    return {
      kind: 'countdown',
      round: 1,
      remaining: Math.ceil(state.resumed_at - now),
      index: -1,
      breakType: 0,
    }
  const spent = elapsed(state, now)
  if (state.status === 'finished' || spent >= total(state.settings))
    return {
      kind: 'finished',
      round: state.settings.rounds,
      remaining: 0,
      index: state.settings.rounds * 2 - 1,
    }
  let boundary = 0
  const segments = durations(state.settings)
  for (let index = 0; index < segments.length; index++) {
    boundary += segments[index]
    if (spent < boundary)
      return {
        kind: index % 2 ? 'rest' : 'focus',
        round: Math.floor(index / 2) + 1,
        remaining: Math.ceil(boundary - spent),
        index,
        breakType: Math.floor(index / 2) % 3,
      }
  }
}
export function initial(settings = defaults) {
  return {
    settings: { ...settings },
    status: 'ready',
    elapsed: 0,
    resumed_at: null,
    revision: 0,
  }
}
export function transition(state, command, now) {
  const next = {
    ...state,
    elapsed: elapsed(state, now),
    revision: state.revision + 1,
  }
  if (command === 'reset') return initial(state.settings)
  if (command === 'start' || command === 'resume')
    Object.assign(next, { status: 'running', resumed_at: now })
  if (command === 'pause')
    Object.assign(next, { status: 'paused', resumed_at: null })
  if (command === 'end')
    Object.assign(next, {
      status: 'finished',
      elapsed: total(state.settings),
      resumed_at: null,
    })
  if (command === 'skip') {
    let boundary = 0
    for (const duration of durations(state.settings)) {
      boundary += duration
      if (boundary > next.elapsed) break
    }
    Object.assign(next, {
      elapsed: boundary,
      resumed_at: next.status === 'running' ? now : null,
    })
    if (boundary >= total(state.settings)) next.status = 'finished'
  }
  return next
}
export function validSettings(settings) {
  return (
    settings &&
    ['focus', 'rest', 'rounds'].every(
      (key) =>
        Number.isInteger(settings[key]) &&
        settings[key] >= 1 &&
        settings[key] <= (key === 'rounds' ? 12 : 120),
    )
  )
}
export function formatTime(seconds) {
  return `${Math.floor(seconds / 60)
    .toString()
    .padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`
}
export function scheduleText(settings) {
  const minutes = total(settings) / 60
  const time = [
    Math.floor(minutes / 60) ? `${Math.floor(minutes / 60)} hr` : '',
    minutes % 60 ? `${minutes % 60} min` : '',
  ]
    .filter(Boolean)
    .join(' ')
  return `${settings.rounds} focus round${settings.rounds === 1 ? '' : 's'} · ${settings.rounds - 1} break${settings.rounds === 2 ? '' : 's'} · ${time}`
}
